import { Component, Input, AfterViewInit, ElementRef} from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { getChartColorMap } from "../../achart/achart.colors";
import { ColorEvent } from "ngx-color";
import * as jQuery from "jquery";

import * as $ from "jquery";

@Component({
    selector: "modal-label",
    template: require('./chart.label.component.html'),
    styles: [require('./chart.label.component.css')]
})
export class ChartLabelModal implements AfterViewInit {
    labelData: ILabelAnnotationData={
        labelText: ""
    };

    private _labelText: string="";
    get labelText(): string {
        return this._labelText;
    }
    set labelText(v: string) {
        this._labelText=v;
        this.labelData.labelText=v;
    }

    private _fontColor : string="White";
    public get fontColor(): string {
        return this._fontColor;
    }
    public set fontColor(v : string) {
        this._fontColor = v;
        this.labelData.fontColor=v;
    }

    private _backgroundColor : string="Red";
    public get backgroundColor(): string {
        return this._backgroundColor;
    }
    public set backgroundColor(v : string) {
        this._backgroundColor = v;
    }

    private _fontSize : string="10px";
    public get fontSize(): string {
        return this._fontSize;
    }
    public set fontSize(v : string) {
        this._fontSize = v;
        this.labelData.fontSize=v;
    }

    private _bold : boolean=false;
    public get bold(): boolean {
        return this._bold;
    }
    public set bold(v : boolean) {
        this._bold = v;
        this.labelData.bold=v;
    }

    private _italic : boolean=false;
    public get italic(): boolean {
        return this._italic;
    }
    public set italic(v : boolean) {
        this._italic = v;
        this.labelData.italic=v;
    }

    private _underline : boolean=false;
    public get underline(): boolean {
        return this._underline;
    }
    public set underline(v : boolean) {
        this._underline = v;
        this.labelData.underline=v;
        if(v) {
            this._overline=false;
            this._lineThrough=false;
            this.labelData.overline=false;
            this.labelData.lineThrough=false;
        }
    }

    private _overline : boolean=false;
    public get overline(): boolean {
        return this._overline;
    }
    public set overline(v : boolean) {
        this._overline = v;
        this.labelData.overline=v;
        if(v) {
            this._underline=false;
            this._lineThrough=false;
            this.labelData.underline=false;
            this.labelData.lineThrough=false;
        }
    }

    private _lineThrough : boolean=false;
    public get lineThrough(): boolean {
        return this._lineThrough;
    }
    public set lineThrough(v : boolean) {
        this._lineThrough = v;
        this.labelData.lineThrough=v;
        if(v) {
            this._underline=false;
            this._overline=false;
            this.labelData.underline=false;
            this.labelData.overline=false;
        }
    }

    private _center : boolean=false;
    public get center(): boolean {
        return this._center;
    }
    public set center(v : boolean) {
        this._center = v;
        this.labelData.center=v;
        if(v) {
            this._left=false;
            this._right=false;
            this.labelData.left=false;
            this.labelData.right=false;
        }
    }

    private _left : boolean=false;
    public get left(): boolean {
        return this._left;
    }
    public set left(v : boolean) {
        this._left = v;
        this.labelData.left=v;
        if(v) {
            this._right=false;
            this._center=false;
            this.labelData.right=false;
            this.labelData.center=false;
        }
    }

    private _right : boolean=false;
    public get right(): boolean {
        return this._right;
    }
    public set right(v : boolean) {
        this._right = v;
        this.labelData.right=v;
        if(v) {
            this._left=false;
            this._center=false;
            this.labelData.left=false;
            this.labelData.center=false;
        }


        



    }

    constructor(public activeModal: NgbActiveModal,private element: ElementRef) {
      //  this.labelData.backgroundColor=this.backgroundColor;
        this.labelData.fontColor=this.fontColor;
        this.labelData.fontSize=this.fontSize;
        this.labelData.center=this.center;
        this.labelData.left=this.left;
        this.labelData.right=this.right;
        this.labelData.underline=this.underline;
        this.labelData.lineThrough=this.lineThrough;
        this.labelData.overline=this.overline;
        this.labelData.bold=this.bold;
        this.labelData.italic=this.italic;
        this.labelData.labelText=this.labelText;
    }

    // backgroundColorChange($event: ColorEvent): void {
    //     this.backgroundColor=`rgb(${$event.color.rgb.r},${$event.color.rgb.g},${$event.color.rgb.b},0.5)`;
    // }

    fontColorChange($event: ColorEvent): void {
        this.fontColor=`rgb(${$event.color.rgb.r},${$event.color.rgb.g},${$event.color.rgb.b},0.8)`;
    }

    ngAfterViewInit (): void {
        $(this.element.nativeElement).find(".raised-bg").hide();
        $(this.element.nativeElement).find(".swatches-picker").css("width","220px");
        $(this.element.nativeElement).find(".swatches-overflow").mCustomScrollbar(<any>{
            axis:"y",
            theme: "inset-3",
            scrollbarPosition:"outside",
            alwaysShowScrollbar:1,
            scrollButtons:{
                enable: true
            },
            advanced:{
                autoExpandHorizontalScroll:true
            },
            mouseWheel:{
                enable: true
            },
            scrollInertia:150,
            updateOnContentResize: true
            // axis:"y",
            // theme: "inset-3",// "minimal-dark",
            // scrollbarPosition: "outside",
            // alwaysShowScrollbar: 1, // 0,1,2
            // scrollButtons:{
            //     enable:true
            // },
            // advanced: {
            //     autoExpandHorizontalScroll: "yx"
            // }
        });
        $(this.element.nativeElement).find('.swatchclick').on('click', function (e:any) {
          
            var target = $(e.target);
            if(target.attr("class")!="swatch")
            {
               e.stopPropagation();
            }
          //  alert(target);
         //   if(target.hasClass("keepopen") || target.parents(".keepopen").length){
         //       return false; // returning false should stop the dropdown from hiding.
         //   }else{
          //      return true;
          //  }
        });

    }
}

export interface ILabelAnnotationData {
    labelText: string;
    fontColor?: string;
   // backgroundColor?: string;
    fontSize?: string;
    bold?: boolean;
    italic?: boolean;
    underline?: boolean;
    overline?:boolean;
    lineThrough?: boolean;
    center?: boolean;
    left?: boolean;
    right?: boolean;
}